import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TimeseriesState } from './time-series.reducer';
export const selectTimeSeriesData = createFeatureSelector<TimeseriesState>('timeSeries');

export const selectedTimeSeriesItems = createSelector(selectTimeSeriesData, (state) => {
  return state.data;
});
